import type { ComponentType } from 'react';

import { allCompaniesFlows } from '../../constants/general/allCompaniesFlows';
import type { AllCompaniesNames } from '../../types/general';

import { isValidFlowName } from './isValidFlowName';

type Flow = ComponentType | undefined;

export const getFlow = (company: AllCompaniesNames, flow: string | null): Flow => {
  if (!flow || !isValidFlowName(company, flow)) {
    return undefined;
  }

  return allCompaniesFlows[company][flow];
};
